"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAPIPath = '/public/';
exports.getApiPath = function (baseAPIPath, urlPath) {
    return baseAPIPath || urlPath || exports.defaultAPIPath;
};
//# sourceMappingURL=utils.js.map